import createCatalogService from './catalogService'

export default createCatalogService('/Telas/MetodoPagamento')
